import { Image } from '@opendoor/atoms/image';
import { MAPBOX_ACCESS_TOKEN } from 'helpers/globals';

export const StaticPropertyMap = ({
  latitude,
  longitude,
}: {
  latitude: number;
  longitude: number;
}) => {
  // The Static Images API does not support the interactive map's Standard style.
  const style = 'mapbox/streets-v12';
  const marker = `pin-s+23201d(${longitude},${latitude})`;
  return (
    <Image
      alt="Map showing the property location"
      className="h-full w-full object-cover"
      src={`https://api.mapbox.com/styles/v1/${style}/static/${marker}/${longitude},${latitude},12,0/640x360@2x?access_token=${MAPBOX_ACCESS_TOKEN}`}
    />
  );
};
